import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import axios from 'axios';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin/portal/statements/trend`;
const eur = (c) => new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format((c || 0) / 100);
const sel = 'h-9 bg-[#050505] border border-[#1F242C] text-white text-sm px-2 rounded-sm';
const MONTHS = ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'];
const label = (m) => `${MONTHS[Number(m.slice(5, 7)) - 1]} ${m.slice(2, 4)}`;

export default function AdminTrend({ headers }) {
  const [f, setF] = useState({ service: '', user_id: '' });
  const [metric, setMetric] = useState('count');
  const [data, setData] = useState(null);
  useEffect(() => {
    setData(null);
    axios.get(API, { headers, params: { service: f.service || undefined, user_id: f.user_id || undefined } }).then((r) => setData(r.data));
  }, [f]); // eslint-disable-line react-hooks/exhaustive-deps
  const rows = (data?.months || []).map((m) => ({ ...m, label: label(m.month), eur: m.net_cents / 100 }));
  return (
    <div className="border-t border-[#1F242C] pt-4" data-testid="admin-trend">
      <div className="flex flex-wrap items-center gap-2 mb-3">
        <p className="text-sm text-[#BFBFBF] flex-1 min-w-[180px]">Andamento ultimi 12 mesi</p>
        <select value={f.service} onChange={(e) => setF({ ...f, service: e.target.value })} className={sel} data-testid="trend-service">
          <option value="">Tutti i servizi</option>{(data?.services || []).map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
        <select value={f.user_id} onChange={(e) => setF({ ...f, user_id: e.target.value })} className={sel} data-testid="trend-client">
          <option value="">Tutti i clienti</option>{(data?.clients || []).map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
        {[['count', 'Richieste'], ['eur', 'Importo']].map(([k, l]) => (
          <button key={k} onClick={() => setMetric(k)} className={`h-9 px-3 text-xs border rounded-sm ${metric === k ? 'border-[#D4AF37] text-[#D4AF37]' : 'border-[#1F242C] text-[#8A8F97]'}`} data-testid={`trend-metric-${k}`}>{l}</button>
        ))}
      </div>
      {!data ? <Loader2 className="animate-spin text-[#D4AF37]" /> : (
        <div className="h-64" data-testid="trend-chart">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={rows} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
              <CartesianGrid stroke="#1F242C" vertical={false} />
              <XAxis dataKey="label" tick={{ fill: '#8A8F97', fontSize: 11 }} axisLine={{ stroke: '#1F242C' }} tickLine={false} />
              <YAxis tick={{ fill: '#8A8F97', fontSize: 11 }} axisLine={false} tickLine={false} allowDecimals={metric === 'eur'} width={48} />
              <Tooltip cursor={{ fill: 'rgba(212,175,55,0.08)' }} contentStyle={{ background: '#0B0D10', border: '1px solid #1F242C', color: '#fff' }}
                formatter={(v, n, p) => [metric === 'eur' ? eur(p.payload.net_cents) : `${v} richieste`, metric === 'eur' ? 'Importo netto' : 'Richieste']} />
              <Bar dataKey={metric} fill="#D4AF37" radius={[2, 2, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
}
